import axios from 'axios'
import { Toast } from 'vant'
import { removeToken, getParam } from '@/utils/auth' // get token from cookie
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})
// request interceptor
// service.interceptors.request.use(
//   config => {
//     // do something before request is sent
//     if (config.method === 'post') { // request is post
//       const formData = new FormData()
//       for (const i in config.data) {
//         if (config.data[i] != null) {
//           formData.append(i, config.data[i])
//         }
//       }
//       config.data = formData
//     }
//     return config
//   },
//   error => {
//     // do something with request error
//     return Promise.reject(error)
//   }
// )
// response interceptor
service.interceptors.response.use(
  async response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (![1, 100].includes(Number(res.code)) && typeof res !== 'string') {
      if (Number(res.code) !== 1000) {
        Toast.fail(res.msg || 'Error')
      } else if (Number(res.code) === 1000) {
        removeToken()
        let url = location.origin
        if (getParam('_platform')) {
          url += '?_platform=android'
        }
        location.href = url + '#/login'
      }
      return Promise.reject(res.msg)
    }
    return res
  },
  error => {
    Toast.fail(error.msg || 'Error')
    return Promise.reject(error)
  }
)
export default service
